"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var moment = require("moment-timezone");

// attempt to figure out what type the value is and parse accordingly
var checkType = function checkType(value) {
  if (moment.isMoment(value)) {
    return "moment";
  } else if (value instanceof Date) {
    return "date";
  }

  // For now, anything that isn`t a date or Moment, try to return the type
  // This won`t work past the trial spec
  return _typeof(value);
};
module.exports = checkType;